import { theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { useManagePermittedRoles } from 'library/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { categoriesActions } from 'reduxStore/categories/slice';
import { selectSites } from 'reduxStore/sites/selectors';
import { Typography } from 'zui/Antd';
import { SelectFontSizeLG } from 'zui/Antd/Select';

const { Text } = Typography;

const EditSiteSelect = ({ siteID, categoryID }) => {
	// ✅ Hooks
	const {
		token: { fontSizeLG }
	} = theme.useToken();
	const dispatch = useDispatch();
	const canEdit = useManagePermittedRoles('updateCategory', {
		103: [siteID]
	});

	// ✅ Redux Selectors
	const sites = useSelector(selectSites);

	// ✅ Local state for editing
	const [editableSiteID, setEditableSiteID] = useState(siteID);

	// ✅ Update editableSiteID when siteID prop changes
	useEffect(() => {
		setEditableSiteID(siteID);
	}, [siteID]);

	// ✅ Handle selection change and dispatch action
	const handleSelectChange = (value) => {
		setEditableSiteID(value);
		dispatch(categoriesActions.updateCategory({ categoryID, data: { siteID: value } }));
	};

	// ✅ Site options
	const options = sites.map((site) => ({
		label: site.name,
		value: site.siteID
	}));
	const siteName = sites.find((site) => site.siteID === siteID)?.name || '-';

	if (!canEdit) {
		return <Text style={{ fontSize: fontSizeLG }}>{siteName}</Text>;
	}

	return (
		<SelectFontSizeLG
			value={editableSiteID || null}
			onChange={handleSelectChange}
			placeholder={'Select Site'}
			options={options}
			showSearch={false}
			virtual={false}
			style={{
				width: 228
			}}
			allowClear
		/>
	);
};

export default EditSiteSelect;
